<template>
  <div>
    <!-- 购物车列表 -->
    <div class="product-view">
      <div id="product-list" ref="product-list">
        <product-item
          :model="item.Product"
          :visableShoppingCart="true"
          v-for="item in shoppingCart"
          :key="item.ProductId"
          :badge="item.Count"
          :imgLazy="false"
          @countChange="countChange"
        >
          <div
            slot="shopping-cart"
            style="color: black"
            v-if="captureScreening"
          >
            x{{ item.Count }}
          </div>
        </product-item>
        <van-divider v-if="captureScreening">
          <span style="color: red"
            >总计:￥{{ (totalPrice / 100.0).toFixed(2) }}元</span
          >
        </van-divider>
      </div>
      <div v-if="!shoppingCart || shoppingCart.length === 0" style="padding-top:20vh;">
        <van-empty description="购物车空空如也" />
      </div>
    </div>

    <!--合计  -->
    <van-submit-bar
      :price="totalPrice"
      button-text="截图保存"
      @submit="screenshot"
      :disabled="totalPrice <= 0"
      style="margin-bottom: 70px"
    >
      <van-button color="#0166b8" icon="clear" round style="height: 40px;" @click="clearShoppingCart">清空</van-button>
    </van-submit-bar>

    <!-- 截图插件 -->
    <canvas ref="canvas" v-show="false"></canvas>
  </div>
</template>
<script>
import ProductItemVue from '../Product/productItem.vue'
import html2canvas from 'html2canvas'

export default {
  name: 'shoppingCart-list',
  components: {
    'product-item': ProductItemVue,
  },
  props: {
    shoppingCartData: {
      Type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      captureScreening: false,
      shoppingCart: this.shoppingCartData,
    }
  },
  computed: {
    totalPrice() {
      let price = 0
      this.shoppingCart.forEach((v) => {
        price += v.Product.Price * v.Count
      })
      return price * 100
    },
  },
  methods: {
    clearShoppingCart(){
      this.$dialog.confirm({
        title:'确认要清空购物车吗?'
      }).then(state=>{
        if(state === 'confirm'){
          this.shoppingCart.splice(0,this.shoppingCart.length)
        }
      })
    },
    countChange(product, count) {
      let index = this.shoppingCart.findIndex((v) => v.ProductId === product.Id)
      if (index >= 0) {
        let item = this.shoppingCart[index]

        if (count <= 0) {
          //数量为0就删掉
          this.shoppingCart.splice(index, 1)
        } else {
          //更新数量
          item.Count = count
        }
      } else if (count > 0) {
        //首次添加
        this.shoppingCart.push({
          ProductId: product.Id,
          Product: product,
          Count: count,
        })
      }
    },
    getTime() {
      const date = new Date() // 假设这是需要转换的日期对象
      const yyyy = date.getFullYear()
      const mm = String(date.getMonth() + 1).padStart(2, '0') // 月份需要加1，并且补零
      const dd = String(date.getDate()).padStart(2, '0') // 日需要补零
      const hour = String(date.getHours()).padStart(2, '0') // 日需要补零
      const minute = String(date.getMinutes()).padStart(2, '0') // 日需要补零
      const second = String(date.getSeconds()).padStart(2, '0') // 日需要补零

      const convertedDate = `${yyyy}${mm}${dd}${hour}${minute}${second}`
      return convertedDate
    },
    captureScreen() {
      let productListDom = document.getElementById('product-list')
      return new html2canvas(productListDom, {
        useCORS: true,
      })
        .then((canvas) => {
          // 将canvas内容转换为图片并下载
          const imgData = canvas.toDataURL('image/png')
          const link = document.createElement('a')
          link.href = imgData

          link.download = `截屏${this.getTime()}.png`
          link.click()
        })
        .catch(() => {
          alert('截图失败，请重试')
        })
    },
    screenshot() {
      try {
        this.captureScreening = true
        this.$toast({
          message: '截图中...',
          forbidClick: true,
          loadingType: 'spinner',
        })
        new Promise((resolve) => {
          setTimeout(() => {
            resolve()
          }, 1000)
        })
          .then(() => {
            return this.captureScreen()
          })
          .then(() => {
            this.captureScreening = false
            this.$toast('截图成功')
          })
          .catch((err) => {
            this.$toast(`截图失败.${err}`)
          })
      } catch (e) {
        console.log(e)
        alert('截图失败.')
      }
    },
  },
}
</script>
<style scoped>
.product-view {
  padding: 10px 5px;
  height: calc(100vh - 80px - 50px);
  overflow-y: scroll;
  font-family: Helvetica, Tahoma, Arial, 'PingFang SC', 'Hiragino Sans GB',
    'Heiti SC', STXihei, 'Microsoft YaHei', SimHei;
}
</style>
